/**
 * A random (v4) UUID, or null in the rare browser without Web Crypto. Callers
 * decide what a missing id means; none of them fall back to Math.random,
 * because these ids join rows server-side.
 */
export function createUuid(): string | null {
  if (typeof crypto === 'undefined') return null

  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  if (typeof crypto.getRandomValues !== 'function') return null

  const bytes = crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
